import { rmsApi } from '../../../state/axios';
import type { HistoryApiResponse, SelectedExportFilter } from '../types/exportTypes';
import { historyApiResponseSchema } from '../utils/exportValidators';

export interface FetchHistoryParams {
  page: number;
  pageSize: number;
  selectedFilters: SelectedExportFilter[];
}

export const buildQueryParams = ({
  page,
  pageSize,
  selectedFilters
}: FetchHistoryParams): Record<string, string> => {
  const params: Record<string, string> = {
    page: page.toString(),
    per_page: pageSize.toString(),
    include_filters: 'true'
  };

  // Add selected filters to params
  selectedFilters.forEach((filter) => {
    if (filter.values.length > 0) {
      params[filter.url] = filter.values.map((v) => v.id).join(',');
    }
  });

  return params;
};

export const fetchExportHistory = async (
  params: FetchHistoryParams
): Promise<HistoryApiResponse> => {
  const queryParams = buildQueryParams(params);
  const queryString = new URLSearchParams(queryParams).toString();
  const response = await rmsApi.get<HistoryApiResponse>(
    `/api/v1/dar/downloaded-reports?${queryString}`
  );
  const parsedData = historyApiResponseSchema.parse(response.data);
  return parsedData;
};
